module.exports = __webpack_public_path__ + "assets/01788dcadee76422ae7410e5638bb235.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/artwork-1.png
// module id = 376
// module chunks = 1